import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
const FaNewspaper = require("react-icons/fa").FaNewspaper;
const FaSignOutAlt = require("react-icons/fa").FaSignOutAlt;
const FaBars = require("react-icons/fa").FaBars;
const FaUsersCog = require("react-icons/fa").FaUsersCog;
const RiSpeakLine = require("react-icons/ri").RiSpeakLine;
const MdOutlineHowToVote = require("react-icons/md").MdOutlineHowToVote;
const RiDashboardFill = require("react-icons/ri").RiDashboardFill;
const FaUserFriends = require("react-icons/fa").FaUserFriends;

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profile, setProfile] = useState<{ name: string; role: string; photo: string } | null>(null);

  const handleLogout = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });

    window.location.href = "/login";
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = document.cookie
          .split("; ")
          .find((row) => row.startsWith("token="))
          ?.split("=")[1];

        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error("Gagal mengambil profil");

        const data = await res.json();
        setProfile({
          name: data.name,
          photo: `${process.env.REACT_APP_API_BASE_URL}/storage/${data.photo}`,
          role: data.role,
        });
      } catch (err) {
        console.error("Gagal fetch profile:", err);
      }
    };

    fetchProfile();
  }, []);

  return (
    <>
      <div className="flex min-h-screen bg-gray-100">
        {/* Sidebar */}
        <aside
          className={`fixed z-40 top-0 left-0 h-screen w-52 bg-black2 text-primary p-4 transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 md:static md:block`}>
          <div className="mb-8">
            <h1 className="text-2xl font-bold">Admin</h1>
            <p className="text-sm text-gray-400">Dashboard</p>
          </div>

          <nav className="flex flex-col gap-2 text-lg">
            <NavLink
              to="/dashboard/beranda"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <RiDashboardFill /> Dashboard
            </NavLink>

            <NavLink
              to="/dashboard/pejabat"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaNewspaper /> Entry Data
            </NavLink>

            <NavLink
              to="/dashboard/aspirasi"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <RiSpeakLine /> Aspirasi
            </NavLink>

            <NavLink
              to="/dashboard/voteKuisioner"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <MdOutlineHowToVote /> Vote
            </NavLink>

            <NavLink
              to="/dashboard/akun"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaUsersCog /> Akun
            </NavLink>

            <NavLink
              to="/dashboard/pengguna"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaUserFriends /> Pengguna
            </NavLink>

            <button onClick={handleLogout} className="flex items-center gap-2 px-2  text-white hover:text-red-400 mt-4">
              <FaSignOutAlt /> Logout
            </button>
          </nav>
        </aside>

        {/* Main content area */}
        <div className="flex-1 flex flex-col h-screen">
          {/* Top navbar */}
          <header>
            <div className="bg-white shadow px-4 py-3 sticky top-0 z-30">
              <div className="flex items-center justify-between">
                {/* Burger menu for mobile */}
                <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-black text-xl md:hidden">
                  <FaBars />
                </button>

                {/* Dummy placeholder untuk spacing */}
                <div className="hidden md:block w-8"></div>

                {/* Profile info */}
                <div className="flex justify-end items-center gap-3">
                  {profile ? (
                    <>
                      <div>
                        <p className="text-sm font-medium text-gray-800">{profile.name}</p>
                        <p className="text-xs text-gray-500 capitalize">{profile.role}</p>
                      </div>
                    </>
                  ) : (
                    <p className="text-gray-500 text-sm">Memuat profil...</p>
                  )}
                </div>
              </div>
            </div>
          </header>

          {/* Outlet for page content */}
          <main className="p-4 flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Overlay (klik luar sidebar) */}
      {sidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden" onClick={() => setSidebarOpen(false)} />}
    </>
  );
};

export default DashboardLayout;
